function wrapXAxisLabels(
  chartCtx: any,
  opts: { maxCharsPerLine: number; maxLines?: number } = {
    maxCharsPerLine: 12,
  },
) {
  // Only bottom x-axis labels
  const labels: NodeListOf<SVGTextElement> = chartCtx.el.querySelectorAll(
    ".apexcharts-xaxis .apexcharts-xaxis-texts-g text",
  );

  labels.forEach((textEl) => {
    // original text (store once)
    const raw =
      textEl.getAttribute("data-raw") ?? (textEl.textContent || "").trim();
    if (!textEl.getAttribute("data-raw")) textEl.setAttribute("data-raw", raw);

    // hard reset
    textEl.textContent = ""; // <- clears any previous text/tspans safely

    const { maxCharsPerLine, maxLines } = opts;

    // word-aware wrapping
    const words = raw.split(/\s+/);
    const lines: string[] = [];
    let line = "";

    for (let i = 0; i < words.length; i++) {
      const w = words[i];
      const test = line ? `${line} ${w}` : w;

      if (test.length > maxCharsPerLine && line) {
        lines.push(line);
        line = w;

        if (maxLines && lines.length >= maxLines - 1) {
          lines.push([line, ...words.slice(i + 1)].join(" "));
          line = "";
          break;
        }
      } else {
        line = test;
      }
    }
    if (line) lines.push(line);

    // append tspans
    const x = textEl.getAttribute("x") || "0";
    lines.forEach((ln, i) => {
      const tspan = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "tspan",
      );
      tspan.setAttribute("x", x);
      tspan.setAttribute("dy", i === 0 ? "0" : "1.2em");
      tspan.textContent = ln;
      textEl.appendChild(tspan);
    });
  });
}

export const getCropBarChartOptions = (
  mode: string | null,
  onUpdate?: () => void,
) => {
  const textColor = mode === "dark" ? "#f1f5f9" : "#1f2937";
  return {
    colors: [],
    series: [
      {
        name: "Cumulative Avg ET (ac-ft/ac)",
        data: [],
      },
    ],
    chart: {
      type: "bar",
      height: "100%",
      fontFamily: "Inter, sans-serif",
      toolbar: {
        show: false,
      },
      events: {
        updated: onUpdate,
      },
      animations: {
        enabled: true,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "70%",
        borderRadiusApplication: "end",
        borderRadius: 10,
        distributed: true,
      },
    },
    tooltip: {
      followCursor: true,
      intersect: false,
      style: {
        fontFamily: "Inter, sans-serif",
        colors: ["gray"],
      },
      y: {
        formatter: function (value: number) {
          return value.toLocaleString();
        },
      },
    },
    states: {
      hover: {
        filter: {
          type: "darken",
          value: 1,
        },
      },
    },
    stroke: {
      show: true,
      width: 0,
      colors: ["transparent"],
    },
    grid: {
      show: false,
      strokeDashArray: 4,
      padding: {
        left: 2,
        right: 2,
        top: -14,
      },
    },
    labels: [],
    dataLabels: {
      // enabled: false,
      enabled: true,
      formatter: function (val: number) {
        return val.toLocaleString(); // adds thousand separators if needed
      },
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        colors: ["#1f2937"], // can also dynamically set for dark mode
      },
    },
    legend: {
      show: false,
      position: "bottom",
      fontFamily: "Inter, sans-serif",
      fontSize: "14px",
      labels: {
        colors: textColor,
      },
    },
    xaxis: {
      floating: false,
      labels: {
        show: true,
        rotate: 0, // 45° angle (use -45 for leaning right)
        rotateAlways: false, // force rotation even if space allows
        trim: true,
        style: {
          fontSize: "5px",
          fontWeight: "bold",
          fontFamily: "Inter, sans-serif",
          cssClass: "text-xs font-normal fill-gray-600 dark:fill-gray-400",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: false,
    },
    fill: {
      opacity: 1,
    },
  };
};

export const updateCropBarChartOptionsForTextMode = (mode: string | null) => {
  const textColor = mode === "dark" ? "#f1f5f9" : "#1f2937";
  return {
    legend: {
      labels: { colors: textColor },
    },
  };
};
